import React from 'react';
import { Search, Facebook, Twitter, Linkedin, Youtube } from 'lucide-react';
import Container from './Container';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white pt-20 pb-10">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center mb-6">
              <Search className="h-8 w-8 text-blue-500" />
              <span className="ml-2 text-xl font-bold">RoofersWantSEO</span>
            </div>
            <p className="text-gray-400 mb-6">
              Empowering roofing companies with cutting-edge SEO solutions to dominate their local markets.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-500">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500">
                <Twitter className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500">
                <Linkedin className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500">
                <Youtube className="h-6 w-6" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Products</h3>
            <ul className="space-y-4">
              <li><a href="#" className="text-gray-400 hover:text-blue-500">OTTO</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-500">Search Atlas Suite</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-500">GBP Optimization</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-500">Local SEO Tools</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Company</h3>
            <ul className="space-y-4">
              <li><a href="#" className="text-gray-400 hover:text-blue-500">About Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-500">Case Studies</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-500">Blog</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-500">Contact</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Support</h3>
            <ul className="space-y-4">
              <li><a href="#" className="text-gray-400 hover:text-blue-500">Help Center</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-500">Documentation</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-500">API Reference</a></li>
              <li><a href="#" className="text-gray-400 hover:text-blue-500">Status</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} RoofersWantSEO. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-blue-500 text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500 text-sm">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-500 text-sm">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;